// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"1abf9802","399":"6e70e08e","418":"7635b600"}[chunkId] + ".chunk.js";
};